import { dew as _BasicAuthDew } from "./BasicAuth";
import { dew as _BearerTokenDew } from "./BearerToken";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BearerToken = exports.BasicAuth = void 0;
  var BasicAuth_1 = _BasicAuthDew();
  Object.defineProperty(exports, "BasicAuth", {
    enumerable: true,
    get: function () {
      return BasicAuth_1.BasicAuth;
    }
  });
  var BearerToken_1 = _BearerTokenDew();
  Object.defineProperty(exports, "BearerToken", {
    enumerable: true,
    get: function () {
      return BearerToken_1.BearerToken;
    }
  });
  return exports;
}